import React from 'react'

import List from '../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'

const IncidentDivisionList = () => {
  const columns = [
    { header: 'Id', value: (item) => item.id },
    { header: 'Name', value: (item) => item.name, isLink: true },
  ]
  return (
    <List
      title="Incident Divisions"
      routeName={ROUTE_NAME}
      apiUrl={API_URL}
      columns={columns}
    />
  )
}

export default IncidentDivisionList
